import { render, staticRenderFns } from "./IntegrationList.vue?vue&type=template&id=47f82ea4&scoped=true"
import script from "./IntegrationList.vue?vue&type=script&lang=js"
export * from "./IntegrationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f82ea4",
  null
  
)

export default component.exports